export default "__VITE_ASSET__BUOJO9vh__"